/* Calendario confirmado, hora de Paraguay y precios reales en guaraníes. */
(function (root) {
  const zone = 'America/Asuncion';
  const partsFormat = new Intl.DateTimeFormat('en-CA', {
    timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function calendar(now = new Date(), input = '') {
    const entries = String(input).split(',').map(x => x.trim());
    if (!entries.length || entries.some(x => !/^[1-7]$/.test(x))) return null;
    const days = new Set(entries.map(Number));
    const p = Object.fromEntries(partsFormat.formatToParts(now).map(x => [x.type, x.value]));
    // UTC holds the calendar date only. The browser's local timezone never participates.
    const date = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    const weekday = d => d.getUTCDay() || 7;
    const seconds = +p.hour * 3600 + +p.minute * 60 + +p.second;
    const remaining = Math.max(0, 13 * 3600 - seconds);
    const orderDay = new Date(date);
    if (!days.has(weekday(orderDay)) || !remaining) {
      do { orderDay.setUTCDate(orderDay.getUTCDate() + 1); } while (!days.has(weekday(orderDay)));
    }
    const delivery = new Date(orderDay);
    do { delivery.setUTCDate(delivery.getUTCDate() + 1); } while (!days.has(weekday(delivery)));
    const tomorrow = new Date(date); tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
    const countdown = remaining > 0 && days.has(weekday(date)) && delivery.getTime() === tomorrow.getTime();
    const day = delivery.toLocaleDateString('es-PY', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
    const timer = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60].map(x => String(x).padStart(2, '0')).join(':');
    return { countdown, remaining, timer, day, date: delivery.toISOString().slice(0, 10),
      text: countdown ? `Pedí en las próximas ${timer} y lo recibís mañana*` : `Pedí hoy y lo recibís el ${day}*` };
  }
  const formatMoney = cents => '₲ ' + new Intl.NumberFormat('es-PY', { maximumFractionDigits: 0 }).format(Math.round(Number(cents) / 100));
  function dailyPrice(cents, bottles, days) {
    return Number.isFinite(+days) && +days > 0 && +bottles > 0
      ? 'Sale ' + formatMoney(Math.round(Number(cents) / (+bottles * +days) / 100) * 100) + ' por día' : '';
  }
  const api = { calendar, formatMoney, dailyPrice };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ParaguayDelivery = api;
})(typeof window === 'undefined' ? globalThis : window);

/* ============================================================
   tersa.js · versión Shopify
   Precios, packs, suscripción, cuenta atrás y carrito lateral.
   Todo sale de Shopify: variantes (precio y precio de comparación),
   planes de suscripción y carrito real (/cart.js).
   ============================================================ */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const dataEl = $("#tersa-data");
  const D = dataEl ? JSON.parse(dataEl.textContent) : null;

  /* ---------- Formato de dinero de Shopify ---------- */
  const money = cents => new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR'}).format(Number(cents||0)/100);
  const m = money;
  const perBottleMoney = cents => m(cents);

  /* ---------- Cabecera ---------- */
  const header = $("#header");
  if (header) addEventListener("scroll", () => header.classList.toggle("is-scrolled", scrollY > 8), { passive: true });

  /* ---------- Aparición al hacer scroll ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
  }), { rootMargin: "0px 0px -8% 0px" });
  $$(".reveal").forEach((el, i) => { el.style.transitionDelay = (i % 4) * 70 + "ms"; io.observe(el); });

  /* ---------- Antes/después: flechas ---------- */
  $$("[data-rail]").forEach(wrap => {
    const rail = $(".rail", wrap);
    $$("[data-scroll]", wrap).forEach(b => b.addEventListener("click", () => {
      const f = rail.querySelector("figure");
      if (f) rail.scrollBy({ left: (f.offsetWidth + 16) * Number(b.dataset.scroll), behavior: "smooth" });
    }));
  });

  /* ---------- Carrito lateral (todas las páginas) ---------- */
  const drawer = $("#drawer");
  const openCart = () => { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); };
  const closeCart = () => { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); };
  $$("[data-cart-open]").forEach(b => b.addEventListener("click", async e => { e.preventDefault(); await renderCart(); openCart(); }));
  $$("[data-close]", drawer).forEach(el => el.addEventListener("click", closeCart));
  document.addEventListener("keydown", e => e.key === "Escape" && closeCart());

  const V = (D && D.variants) || {};
  const T = (D && D.t) || {};

  // La guía está siempre incluida con los packs de 3 y 5.
  const guideOpen = () => true;
  let sub = !!($("#subscribe") && $("#subscribe").checked);
  const canSub = id => D && D.subscriptionEnabled && V[id] && V[id].plan;
  const priceOf = (id, withSub = sub) => (withSub && canSub(id) ? V[id].plan.price : V[id].price);
  const wasOf = (id, withSub = sub) => {
    const v = V[id];
    if (v.compare > v.price) return v.compare;
    return 0;
  };

  async function getCart() {
    return cartRequest("/cart.js", { headers: { Accept: "application/json" } });
  }

  const escapeCartText = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const cartBundleDetails = id => {
    const option = $(`.pack[data-pack="${id}"]`);
    return option ? { bottles: Math.max(1, Number(option.dataset.bottleCount || 1)), free: Math.max(0, Number(option.dataset.freeBottles || 0)) } : null;
  };

  async function renderCart(cart) {
    cart = cart || await getCart();
    const count = $("#cartCount");
    if (count) { count.textContent = cart.item_count; count.classList.toggle("has", cart.item_count > 0); }
    let saved = 0, freeBottles = 0, includesGuide = false;
    const guideGift = document.querySelector('.gift img[src*="lisse-regalo-guia"]')?.closest('.gift');
    const bottleGift = $('.gift[data-massager-gift]');
    $("#cartBody").innerHTML = cart.items.length ? cart.items.map((it, i) => {
      const v = V[it.variant_id];
      const unitWas = v && v.compare > v.price ? v.compare : 0;
      const lineWas = unitWas * it.quantity;
      const lineSave = lineWas > it.final_line_price ? lineWas - it.final_line_price : 0;
      saved += lineSave;
      const bundle = cartBundleDetails(it.variant_id);
      if (bundle) freeBottles += bundle.bottles * it.quantity;
      if (v && guideGift && guideOpen() && v.position >= Number(guideGift.dataset.giftMin)) includesGuide = true;
      const planName = it.selling_plan_allocation ? " · " + T.subShort : "";
      return `<div class="line">
        <img src="${escapeCartText((v && v.image) || it.image || "")}" alt="" width="64" height="64">
        <div><b>Lissé Mini</b><small>${bundle ? `Pack de ${bundle.bottles} ${bundle.bottles === 1 ? 'unidad' : 'unidades'}` : escapeCartText(it.variant_title || '')}${escapeCartText(planName)}</small>${bundle ? `<p class="line__unit">${perBottleMoney(it.final_line_price / (bundle.bottles * it.quantity))} por unidad</p>` : ''}<div class="cart-quantity" aria-label="Cantidad de packs"><button type="button" data-cart-line="${i+1}" data-cart-quantity="${it.quantity-1}" aria-label="Reducir cantidad de packs" ${it.quantity<=1?'disabled':''}>−</button><span aria-label="${it.quantity} packs">${it.quantity}</span><button type="button" data-cart-line="${i+1}" data-cart-quantity="${it.quantity+1}" aria-label="Aumentar cantidad de packs">+</button></div></div>
        <div class="line__r">${lineWas > it.final_line_price ? `<s>${m(lineWas)}</s>` : ""}<b>${m(it.final_line_price)}</b>${lineSave ? `<span class="line__save">${escapeCartText((T.saveTag || 'Ahorrás {amt}').replace("{amt}", m(lineSave)))}</span>` : ""}<button type="button" data-rm="${i + 1}">${escapeCartText(T.remove || 'Quitar')}</button></div>
      </div>`;
    }).join("") : `<div class="cart__empty"><strong>Tu bolsa está esperando su Lissé</strong><p>Elige tu pack y llévate tus regalos incluidos.</p><button type="button" class="btn btn--primary" data-empty-shop>Elegir mi pack</button></div>`;
    $("#cartTotal").textContent = m(cart.total_price);
    $("#cartSaved").hidden = !saved;
    $("#cartSavedAmt").textContent = m(saved);
    const benefits = $('#cartBundleBenefits');
    if (benefits) {
      benefits.hidden = !freeBottles && !includesGuide;
      $('#cartBottleBenefit').hidden = !freeBottles;
      $('#cartFreeBottles').textContent = `${freeBottles} ${freeBottles === 1 ? 'masajeador de cuero cabelludo' : 'masajeadores de cuero cabelludo'}`;
      $('#cartBottleValue').textContent = bottleGift ? m(999 * freeBottles) : '';
      if (bottleGift?.querySelector('img')) $('#cartBottleImage').src = bottleGift.querySelector('img').src;
      $('#cartGuideBenefit').hidden = !includesGuide;
      $('#cartGuideValue').textContent = guideGift?.querySelector('.gift__tag s')?.textContent || '';
      if (guideGift?.querySelector('img')) $('#cartGuideImage').src = guideGift.querySelector('img').src;
    }
    // Informa la guía por contenido del carrito, nunca por una ventana personal.
    const guideNote = includesGuide ? 'Incluida con tu compra · Guía PDF' : 'Sin guía';
    if (cart.items.length && (cart.attributes || {})['Guía de regalo'] !== guideNote) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Guía de regalo': guideNote } }) }).catch(() => {});
    }
    const checkout = $('#cartCheckout');
    if (checkout) checkout.disabled = !cart.items.length;
    if (checkout) checkout.querySelector('span').textContent = cart.items.length ? `Continuar al pago · ${m(cart.total_price)}` : 'Elige tu pack para continuar';
    document.querySelector('[data-empty-shop]')?.addEventListener('click', () => {closeCart();document.querySelector('#buy')?.scrollIntoView({behavior:'smooth'});});
    const updateQuantity = async (line, quantity) => {
      const status = document.querySelector('#cartFeedback');
      status.hidden = true;
      document.querySelectorAll('[data-cart-line],[data-rm]').forEach(b=>b.disabled=true);
      if(checkout) checkout.disabled = true;
      try {
        const response = await fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity})});
        if(!response.ok) throw new Error('No hemos podido actualizar tu bolsa. Inténtalo de nuevo.');
        await renderCart(await response.json());
      } catch(error) {
        status.textContent=error.message;status.hidden=false;
        document.querySelectorAll('[data-cart-line],[data-rm]').forEach(b=>b.disabled=false);
        if(checkout) checkout.disabled = !cart.items.length;
      }
    };
    document.querySelectorAll('[data-cart-line]').forEach(b=>b.addEventListener('click',()=>updateQuantity(Number(b.dataset.cartLine),Number(b.dataset.cartQuantity))));
    const shipping = $('.drawer__shipping-total');
    if (shipping) shipping.hidden = !cart.items.length;
    $$("[data-rm]").forEach(b => b.addEventListener("click", async () => {
      await updateQuantity(+b.dataset.rm, 0);
    }));
    // Casilla de suscripción dentro del carrito
    const cs = $("[data-cart-sub]");
    const subbable = cart.items.some(it => canSub(it.variant_id));
    if (cs) { cs.hidden = !subbable; $("#cartSubscribe").checked = cart.items.some(it => it.selling_plan_allocation); }
    // Venta cruzada: un stick más
    const up = $("#upsell");
    if (up && D && D.upsellVariant && V[D.upsellVariant]) {
      up.hidden = !cart.items.length || freeBottles > 0;
      $("#upsellAdd").textContent = "+ " + m(priceOf(D.upsellVariant));
      if (V[D.upsellVariant].image) $("#upsellImg").src = V[D.upsellVariant].image;
    }
  }

  let addingToCart = false;
  async function cartRequest(url, options = {}) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(url, {...options, signal: controller.signal});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'No hemos podido actualizar tu bolsa.');
    return result;
  } finally { clearTimeout(timeout); }
}
async function add(id) {
  if (addingToCart || !V[id]?.available) return;
  addingToCart = true;
  const buttons = [document.querySelector('#addToCart'), document.querySelector('#stickyAdd')].filter(Boolean);
  const feedback = document.querySelector('#purchaseFeedback');
  buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
  if (feedback) { feedback.hidden = false; feedback.textContent = 'Añadiendo tu pack y tus regalos…'; }
  let added = false;
  try {
    const giftCount = cartBundleDetails(id)?.bottles || 1;
    const item = {id: +id, quantity: 1, properties: {
      'Regalo incluido': giftCount + ' masajeador' + (giftCount > 1 ? 'es' : '') + ' de cuero cabelludo',
      'Guía PDF': 'El arte de cuidar tu cabello'
    }};
    if (sub && canSub(id)) item.selling_plan = V[id].plan.id;
    await cartRequest('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [item]})});
    added = true;
    await renderCart();
    const count = $('#cartCount');
    if (count) { count.classList.remove('bump'); void count.offsetWidth; count.classList.add('bump'); }
    openCart();
    if (feedback) feedback.hidden = true;
  } catch (error) {
    // Never retry a POST automatically: it may have reached Shopify already.
    if (added) { location.assign('/cart'); return; }
    if (feedback) {
      feedback.hidden = false;
      const networkError = error.name === 'AbortError' || error instanceof TypeError;
      feedback.textContent = networkError
        ? 'La conexión ha tardado demasiado o se ha interrumpido. Comprueba tu bolsa antes de volver a añadir el pack. '
        : error.message + ' ';
      const link = document.createElement('a');
      link.href = '/cart'; link.textContent = 'Ver mi bolsa';
      feedback.append(link);
    }
  } finally {
    addingToCart = false;
    buttons.forEach(button => { button.disabled = !V[pack]?.available; button.removeAttribute('aria-busy'); });
  }
}

  $$('[data-cod-return]').forEach(b => b.addEventListener('click', e => {
    if (!document.querySelector('[data-cod-app]')?.children.length) return;
    e.preventDefault();
    closeCart();
    if ($('#buy')) $('#buy').scrollIntoView({ behavior: 'smooth' });
    else location.href = '/#buy';
  }));
  if (drawer && Number($('#cartCount')?.textContent || 0) > 0) renderCart();
  if (!D) return; // páginas sin ficha de producto: solo carrito

  /* ---------- Packs, precios y ahorro ---------- */
  const checked = $(".pack input:checked:not(:disabled)") || $(".pack input:not(:disabled)");
  let pack = checked ? checked.value : Object.keys(V)[0];
  if (checked) checked.checked = true;

  function renderPrices() {
    Object.keys(V).forEach(id => {
      $$(`[data-price="${id}"]`).forEach(el => (el.textContent = m(priceOf(id))));
      $$(`[data-value="${id}"]`).forEach(el => (el.textContent = wasOf(id) ? m(wasOf(id)) : ""));
      $$(`[data-unit-price="${id}"]`).forEach(el => {
        const bottles = Number(el.closest('.pack').dataset.bottleCount) || 1;
        el.textContent = perBottleMoney(priceOf(id) / bottles) + ' / unidad';
      });
      $$(`[data-save-tag="${id}"]`).forEach(el => {
        const w = wasOf(id);
        el.textContent = w ? T.saveTag.replace("{amt}", m(w - priceOf(id))) : "";
      });
    });
    $$('[data-daily-price]').forEach(el => {
      const option = el.closest('.pack');
      const text = window.ParaguayDelivery.dailyPrice(priceOf(el.dataset.dailyPrice), option.dataset.bottleCount, D.daysPerBottle);
      el.hidden = !text; el.textContent = text;
    });
    const selectedOption = $(`.pack[data-pack="${pack}"]`);
    const perDay = window.ParaguayDelivery.dailyPrice(priceOf(pack), selectedOption?.dataset.bottleCount, D.daysPerBottle);
    $$('[data-daily-saving]').forEach(el => { el.hidden = !perDay; el.textContent = perDay; });
    $$('[data-selected-variant], form[action*="/cart/add"] input[name="id"]').forEach(el => { el.value = pack; el.dispatchEvent(new Event('change', { bubbles: true })); });
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { ...V[pack], id: Number(pack) } } }));
    const now = priceOf(pack), was = wasOf(pack);
    $$("[data-current-price]").forEach(el => (el.textContent = m(now)));
    $$("[data-current-value]").forEach(el => (el.textContent = was ? m(was) : ""));
    const pos = V[pack].position;
    const saveTxt = was
      ? (pos === 1 || !guideOpen() ? T.saveNoGift : T.save).replace("{amt}", m(was - now)).replace("{pct}", Math.round((1 - now / was) * 100))
      : T.saveStick;
    $$("[data-save]").forEach(el => (el.textContent = saveTxt));
    // % del recuadro de la foto: el mayor descuento de los packs
    const best = Math.max(...Object.keys(V).map(id => (V[id].compare > V[id].price ? 1 - V[id].price / V[id].compare : 0)));
    $$("[data-save-pct]").forEach(el => { el.textContent = best ? "−" + Math.round(best * 100) + "%" : ""; el.hidden = !best; });
    $$("[data-sticky-name]").forEach(el => {
      const lab = $(`.pack[data-pack="${pack}"] .pack__txt b`);
      el.textContent = lab ? lab.textContent : V[pack].title;
    });
    $$(".pack").forEach(el => el.classList.toggle("is-on", el.dataset.pack === String(pack)));
    // Regalos: gratis a partir de cierta variante
    const selectedPack = $(`.pack[data-pack="${pack}"]`);
    const freeBottles = selectedPack ? Number(selectedPack.dataset.freeBottles || 0) : 0;
    $$(".gift").forEach(g => {
      if (g.hasAttribute('data-massager-gift')) {
        const quantity = Math.max(1, Number(selectedPack?.dataset.bottleCount || 1));
        g.querySelector('.gift__name strong').textContent = quantity === 1 ? '1 masajeador de cuero cabelludo' : `${quantity} masajeadores de cuero cabelludo`;
        g.querySelector('.gift__tag s').textContent = m(999 * quantity);
      }
      const on = pos >= +g.dataset.giftMin;
      g.classList.toggle("is-off", !on);
      $("[data-gift-on]", g).hidden = !on; $("[data-gift-off]", g).hidden = on;
      if (g.hasAttribute('data-bottle-gift')) {
        g.hidden = !on || !freeBottles;
        $('[data-bottle-gift-name]', g).textContent = freeBottles === 1 ? '1 bote GRATIS' : `${freeBottles} botes GRATIS`;
        const value = $('[data-bottle-gift-value]', g);
        if (value) value.textContent = m(Number(g.dataset.bottleValue) * freeBottles);
      } else {
        g.hidden = !on;
      }
    });
    document.body.classList.toggle("sub-on", sub);
    $$("[data-sub-chip]").forEach(el => (el.textContent = "−" + D.subPct + "%"));
    $$("[data-sub-title]").forEach(el => (el.textContent = ($("[data-subscribe] b") || el).textContent));
    const btn = $("#addToCart");
    if (btn) btn.disabled = addingToCart || !V[pack].available;
    const stickyPurchase = $("#stickyAdd");
    if (stickyPurchase) stickyPurchase.disabled = addingToCart || !V[pack].available;
    const variant = V[pack];
    const tracked = typeof variant.inventory === 'number';
    const backorder = tracked && variant.inventory <= 0 && variant.inventoryPolicy === 'continue';
    const limitedInventory = variant.available && tracked && variant.inventoryPolicy !== 'continue' && variant.inventory > 0 && variant.inventory <= D.lowStockThreshold;
    const stockRow = $('[data-stock-row]');
    if (stockRow) {
      stockRow.classList.toggle('stock--unavailable', !variant.available);
      stockRow.classList.toggle('stock--backorder', backorder && variant.available);
      const label = !variant.available ? 'Agotado' : backorder ? 'Disponible para pedir' : D.stockText || 'Stock limitado';
      $('[data-stock-label]', stockRow).textContent = label;
      stockRow.classList.toggle('stock--low', limitedInventory);
      $('[data-stock-shipping]', stockRow).hidden = !variant.available || backorder;
    }
    const lowStock = $('[data-low-stock]');
    if (lowStock) {
      const limited = variant.available && tracked && variant.inventoryPolicy !== 'continue' && variant.inventory > 0 && variant.inventory <= D.lowStockThreshold;
      lowStock.hidden = !limited;
      $('[data-low-stock-text]', lowStock).textContent = limited ? `Quedan ${variant.inventory} unidades en stock. Pedí tu pack.` : '';
    }
    const availability = $('[data-product-availability]');
    if (availability) {
      const limited = variant.available && tracked && variant.inventoryPolicy !== 'continue' && variant.inventory > 0 && variant.inventory <= D.lowStockThreshold;
      availability.textContent = !variant.available ? 'Este pack está agotado' : limited
        ? `${variant.inventory <= 5 ? 'Quedan pocas unidades' : 'Poco stock'} · Quedan ${variant.inventory} unidades`
        : pos >= 2 ? 'Ahorra comprando en pack' : 'Elige tu Lissé Mini';
      availability.closest('.purchase-activity').classList.toggle('purchase-activity--low', limited);
    }
    const saving = $('[data-purchase-saving]');
    if (saving) {
      saving.hidden = !variant.available || was <= now;
      $('[data-purchase-saving-amount]', saving).textContent = was > now ? m(was - now) : '';
      const bottles = Math.max(1, Number(selectedPack?.dataset.bottleCount || 1));
      $('[data-bundle-unit]', saving).textContent = `${bottles} ${bottles === 1 ? 'unidad' : 'unidades'} · ${perBottleMoney(now / bottles)} por unidad`;
      $('[data-saving-basis]', saving).textContent = `Respecto al precio anterior del pack: ${m(was)}.`;
    }
  }
  $$(".pack input").forEach(inp => inp.addEventListener("change", () => { pack = inp.value; renderPrices(); }));

  function flash() {
    $$("[data-price], [data-current-price], [data-save], #cartTotal, #cartSavedAmt").forEach(el => {
      el.classList.remove("flash"); void el.offsetWidth; el.classList.add("flash");
    });
  }
  const mainSub = $("#subscribe");
  if (mainSub) mainSub.addEventListener("change", e => { sub = e.target.checked; renderPrices(); flash(); });

  // Suscripción desde el carrito: cambia cada línea con /cart/change.js
  const cartSub = $("#cartSubscribe");
  if (cartSub) cartSub.addEventListener("change", async e => {
    const on = e.target.checked;
    sub = on; if (mainSub) mainSub.checked = on;
    renderPrices();
    const cart = await getCart();
    for (let i = 0; i < cart.items.length; i++) {
      const it = cart.items[i];
      if (!canSub(it.variant_id)) continue;
      await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: i + 1, quantity: it.quantity, selling_plan: on ? V[it.variant_id].plan.id : null }) });
    }
    await renderCart(); flash();
  });

  /* ---------- Corte de entrega en America/Asuncion ---------- */
  const box = $('[data-offerbox]'), offerLabel = $('[data-limited-offer]');
  if (box) box.hidden = true;
  if (offerLabel) offerLabel.hidden = true;
  const countdown = $('[data-countdown]');
  function tickDelivery() {
    const info = null;
    if (countdown) countdown.hidden = false;
    $$('[data-eta]').forEach(el => el.textContent = info ? info.day : 'Envío pendiente de configurar');
    const viewers = $('[data-product-viewers]');
    if (viewers) viewers.hidden = true;
  }
  tickDelivery(); setInterval(tickDelivery, 60000);

  /* ---------- Galería ---------- */
  const mainImg = $("#galleryImg");
  const thumbs = $("#thumbs");
  const gallery = mainImg && mainImg.closest('.gallery');
  const imageButtons = $$('button[data-src]', thumbs || document);
  if (gallery && imageButtons.length) {
    const frame = $('.gallery__main', gallery), video = $('#galleryVideo');
    const pause = $('[data-gallery-pause]', gallery), count = $('[data-gallery-count]', gallery);
    const lightbox = $('[data-gallery-lightbox]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const slides = document.createElement('div');
    slides.className = 'gallery__slides';
    frame.prepend(slides);
    const images = imageButtons.map((button, i) => {
      const image = i === 0 ? mainImg : document.createElement('img');
      image.dataset.src = button.dataset.src;
      image.dataset.srcset = button.dataset.srcset || '';
      image.dataset.sizes = '(min-width:1024px) 45vw, 100vw';
      image.alt = button.getAttribute('aria-label');
      const thumbnail = button.querySelector('img');
      image.width = Number(thumbnail?.getAttribute('width') || 1122);
      image.height = Number(thumbnail?.getAttribute('height') || 1402);
      image.draggable = false;
      image.loading = i === 0 ? 'eager' : 'lazy';
      image.fetchPriority = i === 0 ? 'high' : 'low';
      image.decoding = 'async';
      image.setAttribute('aria-hidden', String(i !== 0));
      return image;
    });
    const clone = image => {
      const copy = image.cloneNode(true);
      copy.removeAttribute('id'); copy.alt = ''; copy.setAttribute('aria-hidden', 'true');
      return copy;
    };
    slides.append(clone(images[images.length - 1]), ...images, clone(images[0]));
    const loadGalleryImage = image => {
      if (image.getAttribute('src')) return;
      image.loading = 'eager';
      image.sizes = image.dataset.sizes;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
    };
    let index = 1, moving = false, paused = false, hovered = false, changedAt = Date.now();
    const activeIndex = () => (index - 1 + images.length) % images.length;
    const mark = () => {
      const active = activeIndex();
      images.forEach((image, i) => image.setAttribute('aria-hidden', String(i !== active)));
      imageButtons.forEach((button, i) => {
        button.classList.toggle('is-active', i === active);
        button.setAttribute('aria-current', String(i === active));
      });
      if (count) count.textContent = `${active + 1} / ${images.length}`;
      frame.dataset.galleryIndex = String(active);
      const buttonBox = imageButtons[active].getBoundingClientRect(), railBox = thumbs.getBoundingClientRect();
      const vertical = matchMedia('(min-width:1024px)').matches;
      if (vertical) thumbs.scrollTo({top:thumbs.scrollTop + buttonBox.top - railBox.top - (railBox.height - buttonBox.height)/2,behavior:'smooth'});
      else thumbs.scrollTo({left:thumbs.scrollLeft + buttonBox.left - railBox.left - (railBox.width - buttonBox.width)/2,behavior:'smooth'});
    };
    const settle = () => {
      if (index === 0 || index === images.length + 1) {
        index = index === 0 ? images.length : 1;
        slides.style.transition = 'none';
        slides.style.transform = `translateX(-${index * 100}%)`;
        requestAnimationFrame(() => requestAnimationFrame(() => { slides.style.transition = ''; }));
      }
      moving = false;
    };
    const go = async next => {
      if (moving || next < 0 || next > images.length + 1) return;
      changedAt = Date.now();
      video.hidden = true; slides.hidden = false;
      if (next === index) { mark(); return; }
      moving = true;
      const image = slides.children[next];
      image.loading = 'eager';
      image.fetchPriority = 'high';
      loadGalleryImage(image);
      if (next === 0) {
        const realLast = images[images.length - 1];
        loadGalleryImage(realLast);
        await realLast.decode().catch(() => {});
      }
      await image.decode().catch(() => {});
      index = next;
      slides.style.transform = `translateX(-${index * 100}%)`;
      mark();
      if (reducedMotion.matches) settle();
    };
    slides.addEventListener('transitionend', event => {
      if (event.target === slides && event.propertyName === 'transform') settle();
    });
    imageButtons.forEach((button, i) => button.addEventListener('click', () => go(i + 1)));
    $$('[data-thumbs-step]', gallery).forEach(button => button.addEventListener('click', () => go(index + Number(button.dataset.thumbsStep))));
    $$('[data-video]', gallery).forEach(button => button.addEventListener('click', () => {
      changedAt = Date.now(); slides.hidden = true; video.hidden = false;
      imageButtons.forEach(imageButton => imageButton.classList.remove('is-active'));
      button.classList.add('is-active');
    }));
    if (pause) pause.addEventListener('click', () => {
      paused = !paused; changedAt = Date.now();
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Reproducir imágenes del producto' : 'Pausar imágenes del producto');
      $('[data-gallery-pause-icon]', pause).toggleAttribute('hidden', paused);
      $('[data-gallery-play-icon]', pause).toggleAttribute('hidden', !paused);
    });
    frame.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovered = true; });
    frame.addEventListener('pointerleave', () => { hovered = false; });
    let start = null;
    frame.addEventListener('pointerdown', event => {
      if (!event.target.closest('button')) start = {x:event.clientX,y:event.clientY};
    });
    frame.addEventListener('pointerup', event => {
      if (!start) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(index + (dx < 0 ? 1 : -1));
    });
    frame.addEventListener('pointercancel', () => { start = null; });
    if (lightbox) {
      $('[data-gallery-zoom]', gallery).addEventListener('click', () => {
        const full = $('img', lightbox), current = images[activeIndex()];
        full.src = imageButtons[activeIndex()].dataset.fullSrc || current.currentSrc || current.src;
        full.alt = current.alt; lightbox.showModal();
      });
      $('[data-gallery-close]', lightbox).addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
      lightbox.addEventListener('close', () => { changedAt = Date.now(); });
    }
    setInterval(() => {
      if (paused || hovered || moving || document.hidden || reducedMotion.matches || !video.hidden || (lightbox && lightbox.open) || Date.now() - changedAt < 7500) return;
      const box = frame.getBoundingClientRect();
      if (Math.min(box.bottom, innerHeight) - Math.max(box.top, 0) < Math.min(180, box.height * .4)) return;
      go(index + 1);
    }, 500);
    mark();
  }

  /* ---------- Vídeos ---------- */
  const actionRail = $("#actionRail");
  // Centre play button while paused; native playback controls while playing.
  const reviewVideos = $$("video", actionRail || document).filter(video => video.closest("#actionRail"));
  reviewVideos.forEach(video => {
    const button = $("[data-review-play]", video.parentElement);
    if (!button) return;
    const showPlay = () => {
      video.controls = false;
      button.hidden = false;
    };
    showPlay();
    video.addEventListener("play", () => {
      reviewVideos.forEach(other => { if (other !== video) other.pause(); });
      video.controls = true;
      button.hidden = true;
    });
    video.addEventListener("pause", showPlay);
    video.addEventListener("ended", showPlay);
    button.addEventListener("click", () => {
      video.controls = true;
      video.play().catch(showPlay);
    });
  });
  $$("[data-action-step]").forEach(btn => btn.addEventListener("click", () => {
    const f = actionRail && actionRail.firstElementChild;
    if (f) actionRail.scrollBy({ left: Number(btn.dataset.actionStep) * (f.offsetWidth + 24) });
  }));

  /* ---------- Botones de compra ---------- */
  const addBtn = $("#addToCart"), stickyBtn = $("#stickyAdd"), upBtn = $("#upsellAdd");
  if (addBtn) addBtn.addEventListener("click", () => add(pack));
  const goToCOD = () => { closeCart(); $('#buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
  if (stickyBtn) stickyBtn.addEventListener('click', () => add(pack));
  // Barra fija: solo cuando el botón principal ya ha quedado por encima de la pantalla
  const sticky = $("#sticky");
  if (sticky && addBtn) {
    const toggleSticky = () => sticky.classList.toggle("is-on", addBtn.getBoundingClientRect().bottom < 0);
    addEventListener("scroll", toggleSticky, { passive: true });
    toggleSticky();
  }
  if (upBtn && D.upsellVariant) upBtn.addEventListener("click", () => add(D.upsellVariant));
  $$("[data-add-variant]").forEach(b => b.addEventListener("click", () => add(b.dataset.addVariant)));

  renderPrices();
})();

/* ============================================================
   salmora-lp.js · menú móvil, barra de anuncios que rota, carruseles, antes/después,
   ventanas (lista de ingredientes y descuento) y vídeos de YouTube a demanda.
   ============================================================ */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get: k => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };

  /* ---------- Menú móvil ---------- */
  const menu = $("#menu");
  if (menu) {
    const toggle = open => { menu.classList.toggle("is-open", open); menu.setAttribute("aria-hidden", String(!open)); document.body.style.overflow = open ? "hidden" : ""; };
    $$("[data-menu-open]").forEach(b => b.addEventListener("click", () => toggle(true)));
    $$("[data-menu-close]", menu).forEach(b => b.addEventListener("click", () => toggle(false)));
    document.addEventListener("keydown", e => e.key === "Escape" && toggle(false));
  }

  /* ---------- Barra de anuncios: un mensaje cada X segundos ---------- */
  $$("[data-rotate]").forEach(bar => {
    const msgs = $$(".announce__msg", bar);
    if (msgs.length < 2 || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let i = 0, paused = false;
    bar.addEventListener("mouseenter", () => (paused = true));
    bar.addEventListener("mouseleave", () => (paused = false));
    setInterval(() => {
      if (paused) return;
      msgs[i].classList.remove("is-on");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-on");
    }, (+bar.dataset.rotate || 4) * 1000);
  });

  /* ---------- Carruseles: flechas, puntos y deslizar ---------- */
  $$("[data-carousel]").forEach(car => {
    const track = $("[data-track]", car), dots = $("[data-dots]", car);
    if (!track) return;
    const items = [...track.children];
    const step = () => (items[1] ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth);
    const pages = () => Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1);
    const index = () => Math.round(track.scrollLeft / step());
    const go = i => track.scrollTo({ left: Math.max(0, Math.min(i, pages() - 1)) * step() });
    function drawDots() {
      if (!dots) return;
      const n = pages();
      dots.innerHTML = n > 1 ? Array.from({ length: n }, (_, i) => `<button type="button" aria-label="Ir a la diapositiva ${i + 1}"></button>`).join("") : "";
      $$("button", dots).forEach((b, i) => b.addEventListener("click", () => go(i)));
      mark();
    }
    function mark() { if (dots) $$("button", dots).forEach((b, i) => b.classList.toggle("is-on", i === index())); }
    const prev = $("[data-prev]", car), next = $("[data-next]", car);
    if (prev) prev.addEventListener("click", () => go(index() - 1));
    if (next) next.addEventListener("click", () => go(index() + 1));
    let raf;
    track.addEventListener("scroll", () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    addEventListener("resize", drawDots);
    drawDots();
  });

  /* ---------- Capturas sociales: dos filas de dos, pases hacia la derecha ---------- */
  $$('[data-social-crops]').forEach(section => {
    const pause = $('[data-social-pause]', section);
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const rows = $$('.social-crops__row', section).map(row => {
      const track = $('.social-crops__track', row);
      const state = { row, track, index: 1, moving: false };
      track.dataset.page = '1';
      const settle = () => {
        if (state.index === 0 || state.index === 3) {
          state.index = state.index === 0 ? 2 : 1;
          track.style.transition = 'none';
          track.style.transform = `translateX(-${state.index * 100}%)`;
          requestAnimationFrame(() => requestAnimationFrame(() => { track.style.transition = ''; }));
        }
        track.dataset.page = String(state.index);
        state.moving = false;
      };
      track.addEventListener('transitionend', event => {
        if (event.target === track && event.propertyName === 'transform') settle();
      });
      state.move = async direction => {
        if (state.moving) return;
        state.moving = true;
        const next = state.index - direction;
        const nextGroup = track.children[next];
        // Load the complete next pair before moving; keep the current pair visible meanwhile.
        await Promise.allSettled($$('img', nextGroup).map(image => {
          image.loading = 'eager';
          return image.decode();
        }));
        state.index = next;
        track.dataset.page = String(next);
        track.style.transform = `translateX(-${next * 100}%)`;
        if (reducedMotion.matches) settle();
      };
      $$('[data-social-step]', row).forEach(button => button.addEventListener('click', () => state.move(Number(button.dataset.socialStep))));
      return state;
    });
    if (pause) pause.addEventListener('click', () => {
      const paused = section.classList.toggle('is-paused');
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? 'Reproducir comentarios' : 'Pausar comentarios');
    });
    setInterval(() => {
      if (document.hidden || reducedMotion.matches || section.classList.contains('is-paused')) return;
      const box = section.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) return;
      rows.forEach(row => row.move(1));
    }, 6000);
  });

  /* ---------- Antes/después: arrastrar, tocar o teclado ---------- */
  $$('[data-skin-comparisons]').forEach(section => {
    const tabs = $$('[data-comparison-go]', section);
    const panels = $$('[data-comparison-panel]', section);
    const select = index => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(next); tabs[next].focus({preventScroll:true});
      });
    });
    const dialog = $('[data-comparison-lightbox]', section);
    $('[data-dialog-close]', dialog).addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    $$('[data-comparison-zoom]', section).forEach(button => button.addEventListener('click', () => {
      const source = $('.skin-compare__photo img', button.closest('[data-comparison-panel]'));
      const full = $('img', dialog);
      full.src = source.currentSrc || source.src; full.alt = source.alt;
      dialog.showModal();
    }));
  });
  $$("[data-ba]").forEach(frame => {
    const range = $(".ba__range", frame);
    const set = pct => { pct = Math.max(0, Math.min(100, pct)); frame.style.setProperty("--p", pct + "%"); range.value = pct; };
    const fromEvent = e => { const r = frame.getBoundingClientRect(); set(((e.clientX - r.left) / r.width) * 100); };
    let dragging = false;
    frame.addEventListener("pointerdown", e => { dragging = true; frame.setPointerCapture(e.pointerId); fromEvent(e); });
    frame.addEventListener("pointermove", e => dragging && fromEvent(e));
    ["pointerup", "pointercancel"].forEach(t => frame.addEventListener(t, () => (dragging = false)));
    range.addEventListener("input", () => set(+range.value));
  });
  $$("[data-ba-go]").forEach(btn => btn.addEventListener("click", () => {
    const sec = btn.closest("section");
    $$("[data-ba]", sec).forEach((f, i) => (f.hidden = i !== +btn.dataset.baGo));
    $$("[data-ba-go]", sec).forEach(b => b.classList.toggle("is-on", b === btn));
  }));

  /* ---------- Ventanas (lista de ingredientes, descuento) ---------- */
  $$("[data-dialog-open]").forEach(b => b.addEventListener("click", () => {
    const d = document.getElementById(b.dataset.dialogOpen);
    if (d && d.showModal) d.showModal();
  }));
  $$("dialog.lp-modal").forEach(d => {
    d.addEventListener("click", e => { if (e.target === d) d.close(); });
    $$("[data-dialog-close]", d).forEach(b => b.addEventListener("click", () => d.close()));
    if (d.hasAttribute("data-auto-open") && d.showModal) d.showModal();
  });

  /* ---------- Botón "Ver ofertas": la × lo esconde durante la visita ---------- */
  const pill = $("#dpill");
  if (pill) {
    if (store.get("dpill-hidden")) pill.classList.add("is-hidden");
    const hide = $("[data-dpill-hide]", pill);
    if (hide) hide.addEventListener("click", () => { pill.classList.add("is-hidden"); store.set("dpill-hidden", "1"); });
  }
  // Fuera de Shopify (vista previa local) el formulario no se envía: enseña el código directamente
  const dform = $("#dform");
  if (dform && !window.Shopify) dform.addEventListener("submit", e => {
    e.preventDefault();
    const code = $("[data-code-reveal]", dform);
    if (!code) return;
    $$(".dmodal__input, button[type=submit]", dform).forEach(el => (el.hidden = true));
    code.hidden = false;
  });
  $$("[data-copy]").forEach(el => el.addEventListener("click", () => navigator.clipboard && navigator.clipboard.writeText(el.dataset.copy)));

  /* ---------- Vídeos de YouTube: se cargan al pulsar ---------- */
  $$("[data-yt]").forEach(b => b.addEventListener("click", () => {
    const f = document.createElement("iframe");
    f.src = `https://www.youtube-nocookie.com/embed/${b.dataset.yt}?autoplay=1&playsinline=1`;
    f.allow = "autoplay; encrypted-media; picture-in-picture";
    f.allowFullscreen = true;
    f.title = b.getAttribute("aria-label") || "Video";
    b.replaceWith(f);
  }));
})();

// Local preview controls: keep the original drawer without attempting a payment.
document.addEventListener('click', event => {
 const checkout=event.target.closest('[data-preview-checkout]');
 if(checkout && ['127.0.0.1','localhost'].includes(location.hostname)){event.preventDefault();const message=document.querySelector('.drawer__guarantee');if(message){message.textContent='Vista previa: los pagos todavía no están conectados.';message.setAttribute('role','status');}}
});
document.querySelector('#news')?.addEventListener('submit', event=>{event.preventDefault();const label=document.querySelector('label[for="nl"]');if(label){label.textContent='Vista previa: no se ha enviado tu email.';label.setAttribute('role','status');}});

